export default function* ofType(iterable, ctor) {
    for (const item of iterable) {
        if (item instanceof ctor) {
            yield item;
        }
    }
}
